<template>
    <div class="table-cell table-cell8"> <!--DONATION AMOUNT EDITOR-->
        <a v-if="!newTeacherId" href="#" class="minus" @click.prevent="decreaseAmount" :disabled='minusDisabled'><i class="fa fa-minus" aria-hidden="true"></i></a>
        ${{currentDonation}}
        <a v-if="!newTeacherId" href="#" class="plus" @click.prevent="riseAmount" :disabled="plusDisabled"><i class="fa fa-plus" aria-hidden="true"></i></a>
    </div>
</template>

<script>
    export default {

        props:{
            newTeacherId:{required:false},
            riseSteps:{required:false,default:1},
            currentAmount:{required:true},
            currentDonation:{required:true},
            fundraiserSlug:{required:true},
            goalAmount:{required:true},
        },

        computed:{
            neededAmount(){
                return this.goalAmount - (this.currentAmount+this.currentDonation);
            },
            plusDisabled(){
                return this.neededAmount == 0;
            },
            minusDisabled(){
                return this.currentDonation == 1;
            }
        },
        methods:{
            riseAmount(){

                let newAmount = this.neededAmount > this.riseSteps ? this.currentDonation+this.riseSteps : this.currentDonation+this.neededAmount;
                kinfEvents.$emit('FundingChange',{
                    fundraiserSlug:this.fundraiserSlug,
                    amount: newAmount
                });
            },
            decreaseAmount(){

                let newAmount = this.currentDonation > this.riseSteps ? this.currentDonation - this.riseSteps : 1;
                kinfEvents.$emit('FundingChange',{
                    fundraiserSlug: this.fundraiserSlug,
                    amount: newAmount
                });
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/views/checkout/components/index/cart-table-subcomponents/DonationAmountEditor.vue